require('../plugins/bootstrap-datepicker.min.js');
// require('../plugins/holder.js');
require('../plugins/js.cookie.min.js');
require('../plugins/select2.min.js');
require('../plugins/jquery.inputmask.min.js');
require('../front/functions.js');
require('../front/help-contact')
require('../front/cookie-banner')
require('../plugins/required.fields.js')
require('./scripts');

